import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    InputType,
    ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_162_bank_payment_voucher: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Bank payment voucher",
        style: {},
        childComponents: [
            {
                componentType: LayoutTypes.FORM,
                Name: "bank_payment_voucher",
                TableName: "vouchers",
                DisplayName: "vouchers",
                columnNumber: "m1 t1 w1",
                style: {
                    padding: 10,
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                },
                Fields: [
                    {
                        componentType: LayoutTypes.FIELD_GROUP,
                        Label: "Bank payment voucher details",
                        BindValue: "bank_payment_voucher_details",
                        style: {
                            direction: FlexDirection.COLUMN,
                        },
                        childComponents: [
                            {
                                IncludeLabel: true,
                                Label: "Voucher No.",
                                PlaceHolder: "Will be auto generated...",
                                IsMandatory: false,
                                BindValue: "txt_voucher_no",
                                Json_Attribute: "voucher_no",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                AutoPopulate: true,
                                IsReadOnly: true,
                                AutoPopulate_format: "BNK_[******]",
                                IsVerticalView: true,
                                inputType: InputType.TEXT,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Jobcard No.",
                                BindValue: "job_card_id",
                                Json_Attribute: "job_card_id",
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                LookupName: "voucher_jobcard",
                                IsMandatory: false,
                                showInSummary: true,
                                IsVerticalView: true,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Voucher date",
                                PlaceHolder: "",
                                IsMandatory: true,
                                BindValue: "txt_voucher_date",
                                Json_Attribute: "voucher_date",
                                componentType: ComponentType.DATE_FIELD,
                                showInSummary: true,
                                IsVerticalView: true,
                                DefaultToday: true,
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "Voucher date is required",
                                    },
                                ],
                            },
                            {
                                IncludeLabel: true,
                                Label: "Narration",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "narration",
                                Json_Attribute: "narration",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: true,
                                IsVerticalView: true,
                                inputType: InputType.TEXT,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Ref No.",
                                PlaceHolder: "Ref No.",
                                IsMandatory: false,
                                BindValue: "txt_Ref_no",
                                Json_Attribute: "ref_no",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: true,
                                IsVerticalView: true,
                                inputType: InputType.TEXT,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Voucher type",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_voucher_type_",
                                Json_Attribute: "voucher_type",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: true,
                                Default_Value: "BankPayment",
                                IsReadOnly: true,
                                IsVerticalView: true,
                                inputType: InputType.TEXT,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Reference date",
                                PlaceHolder: "",
                                IsMandatory: true,
                                BindValue: "txt_reference_date",
                                Json_Attribute: "ref_date",
                                componentType: ComponentType.DATE_FIELD,
                                showInSummary: true,
                                IsVerticalView: true,
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "Reference date is required",
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        componentType: ComponentType.SUB_MODULE,
                        name: "voucher_details",
                        label: "Voucher details",
                        tableName: "voucher_details",
                        // lookupName: "purchase_order_details",
                        // parentField: "txt_voucher_no",
                        BindValue: "voucher_details",
                        NotAllowEmpty:true,
                        childControls: [
                            
                            {
                                IncludeLabel: true,
                                Label: "Debit",
                                PlaceHolder: "",
                                IsMandatory: true,
                                BindValue: "drp_ledger",
                                Json_Attribute: "to_ledger",
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                LookupName: "journal_ledgers",
                                IsVerticalView: true,
                                showInSummary: false,
                                EnableEditForControl: false,
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "Debit is required",
                                    },
                                ],
                            },
                            {
                                IncludeLabel: true,
                                Label: "Debit narration",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_to_narration",
                                Json_Attribute: "to_narration",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: true,
                                IsVerticalView: false,
                                inputType: InputType.TEXT,
                            },
                            {
                                IncludeLabel: true,
                                Label: "Credit",
                                PlaceHolder: "",
                                IsMandatory: true,
                                BindValue: "drp_from_ledger",
                                Json_Attribute: "ledger_id",
                                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                                LookupName: "bank_ledgers",
                                IsVerticalView: true,
                                showInSummary: false,
                                EnableEditForControl: false,
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "Credit is required",
                                    },
                                ],
                            },
                            {
                                IncludeLabel: true,
                                Label: "Credit narration",
                                PlaceHolder: "",
                                IsMandatory: true,
                                BindValue: "txt_remarks",
                                Json_Attribute: "remarks",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: true,
                                IsVerticalView: false,
                                inputType: InputType.TEXT,
                                validation: [
                                    {
                                        rule: ValidationRule.REQUIRED,
                                        message: "Credit narration is required",
                                    },
                                ],
                            },
                            {
                                IncludeLabel: true,
                                Label: "Amount",
                                PlaceHolder: "",
                                IsMandatory: false,
                                BindValue: "txt_amount",
                                Json_Attribute: "amount",
                                componentType: ComponentType.TEXT_FIELD,
                                showInSummary: false,
                                IsReadOnly: false,
                                Default_Value: "0",
                                IsVerticalView: true,
                                inputType: InputType.NUMBER,
                            },
                        ],
                    },
                ],
            },
            {
                componentType: ComponentType.BUTTON,
                name: "Submit",
                Label: "Submit",
                BindValue: "btn_submit",
                onPressAction: "save",
                style: {
                    backgroundColor: "#22c55e",
                    textColor: "#FFFFFF",
                    padding: 12,
                    borderRadius: 8,
                    marginTop: 10,
                },
            },
        ],
    },
];
